import { Container, Row, Col, Form, Alert } from 'react-bootstrap';
import React, { useState } from 'react';
import * as Picklist from "../mc/Picklist";
import AsyncSelect from 'react-select/async';
import Loginheader from './Loginheader';
import Menu from './Menu';

const SampleForm = () => {

    const [individualValue, setIndividualValue] = useState(null);
    const handleIndividualValue = (value) => {
        setIndividualValue(value);
    }

    const [ledgerValue, setLedgerValue] = useState(null);
    const handleLedgerValue = (value) => {
        setLedgerValue(value);
    }

    const [ledgerCorporateValue, setLedgerCorporateValue] = useState(null);
    const handleLedgerCorporateValue = (value) => {
        setLedgerCorporateValue(value);
    }

    const [pCountry, setPCountry] = useState(null);
    const handleCountryValue = (value) => {
        setPCountry(value);
    }

    const [pState, setPState] = useState(null);
    const handleStateValue = (value) => {
        setPState(value);
    }

    const [pCity, setPCity] = useState(null);
    const handleCityValue = (value) => {
        setPCity(value);
    }

    const [pDistrict, setPDistrict] = useState(null);
    const handleDistrictValue = (value) => {
        setPDistrict(value);
    }

    const [utrNo, setUtrNo] = useState(null);
    const handleUTRNumber = (value) => {
        setUtrNo(value);
    }

    return (
        <>
            <Loginheader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>Sample Form</h3>
                    </Col>
                </Row>
                <Row>
                    <Col><hr /></Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Individual</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                value={individualValue}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={Picklist.fetchIndividualProfilePicklist} // location = 1 , 2
                                onInputChange={Picklist.handleInputChange}
                                formatOptionLabel={Picklist.formatOptionLabel}
                                components={{ Menu: Picklist.menu }}
                                onChange={handleIndividualValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant="success">
                            Selected Value : {JSON.stringify(individualValue || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Ledger</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                value={ledgerValue}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchLedgerAllowedPicklist(search, 1)} // location = 1 , 2
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleLedgerValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant="success">
                            Selected Value : {JSON.stringify(ledgerValue || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Corporate</Form.Label>
                            <AsyncSelect
                                cacheOptions
                                defaultOptions
                                value={ledgerCorporateValue}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchLedgerPicklistByType(search, 'CORPORATE', 1)} // location = 1 , 2
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleLedgerCorporateValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant="success">
                            Selected Value : {JSON.stringify(ledgerCorporateValue || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Country<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={pCountry}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchCountryPicklist(search, '')}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleCountryValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant='success'>
                            Selected Value : {JSON.stringify(pCountry || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>State<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={pState}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchStatePicklist(search, '')}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleStateValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                        ``                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant='success'>
                            Selected Value : {JSON.stringify(pState || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>District<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={pDistrict}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchDistrictPicklist(search, '')}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleDistrictValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant='success'>
                            Selected Value : {JSON.stringify(pDistrict || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>UTR No.<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={pCity}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchCityPicklist(search, '')}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleCityValue}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant='success'>
                            Selected Value : {JSON.stringify(pCity || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>UTR No.<span className="colorThemeRed">*</span></Form.Label>
                            <AsyncSelect
                                cacheOptions={false}
                                defaultOptions={false}
                                value={utrNo}
                                getOptionLabel={e => e.label + ' '}
                                getOptionValue={e => e.id}
                                loadOptions={(search) => Picklist.fetchUTRNoPicklist(search, '')}
                                onInputChange={Picklist.handleInputChange}
                                onChange={handleUTRNumber}
                            >
                            </AsyncSelect>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Alert variant='success'>
                            Selected Value : {JSON.stringify(utrNo || {}, null, 2)}
                        </Alert>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default SampleForm;
